// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "style/" + chunkId + "." + {"154":"e8a1c832440350645918","481":"f29c771dddfb494c51a2","815":"4fe0d1529136c8ec7ff8","918":"8992563e7489ab2e6642"}[chunkId] + ".css";
};